import React, {useCallback, useEffect, useMemo, useState} from 'react'
import { getCurrentUser } from '../utils/auth'
import {format} from 'date-fns'
import "./Facilities.css"
import { useNavigate } from "react-router-dom"
import { BsFillPencilFill, BsFillTrashFill, BsFileTextFill, BsTable, BsLightbulbFill } from 'react-icons/bs'
import ModalProtocolEdit from "./ModalProtocolEdit"
import ModalProtocolEditData from "./ModalProtocolEditData"
import ModalProtocolSessions from './ModalProtocolSessions'
import ModalProtocolDelete from './ModalProtocolDelete'
import ModalProtocolNotes from './ModalProtocolNotes'
import ModalFrequencySearch from './ModalFrequencySearch'
import ModalTreatedSymptoms from './ModalTreatedSymptoms'
import Caret from './Icon/Caret'
import { Link } from 'react-router-dom'

const Protocols = ({deleteRow}) => {
    const tokenPayload = getCurrentUser() || {};
    const userScopes = tokenPayload.scopes || [];
    const currentUserTypeId = Number(tokenPayload?.user_type_id ?? tokenPayload?.user_type ?? 0);
    const tokenUserTypeDescription = String(tokenPayload?.user_type_description ?? tokenPayload?.description ?? '').trim().toLowerCase();
    const hasReadPermission = userScopes.includes('read:protocolData');
    const isCreatorUser = currentUserTypeId === 10 || tokenUserTypeDescription.includes('creator');
    const navigate = useNavigate();
    const permissionScope = 'protocolData'
    const fetchAllProtocolsUrl = process.env.REACT_APP_API_URL_BASE + '/protocols/view'
    const fetchSingleProtocolUrl = process.env.REACT_APP_API_URL_BASE + '/protocols/protocol/*id*/view'
    const fieldsNoSort = ["Info", "Active", "Actions", "ID"]
    const headers = [
        {
            id: 0,
            KEY: "info",
            LABEL: "Info",
            CLASS: "icons-width"
        },
        {
            id: 1,
            KEY: "id",
            LABEL: "ID",
            CLASS: "left"
        },
        {
            id: 2,
            KEY: "name",
            LABEL: "Name",
            CLASS: "left"
        },
        {
            id: 3,
            KEY: "description",
            LABEL: "Description",
            CLASS: "left"
        },
        {
            id: 4,
            KEY: "protocol_type_description",
            LABEL: "Type",
            CLASS: ""
        },
        {
            id: 5,
            KEY: "music_type",
            LABEL: "Music",
            CLASS: ""
        },
        {
            id: 6,
            KEY: "is_active",
            LABEL: "Active",
            CLASS: ""
        },
        {
            id: 7,
            KEY: "created_on",
            LABEL: "Created",
            CLASS: ""
        },
        {
            id: 7,
            KEY: "last_updated",
            LABEL: "Updated",
            CLASS: ""
        },
        {
            id: 9,
            KEY: "actions",
            LABEL: "Actions",
            CLASS: "left"
        }
    ]

    const [protocolEdit, setProtocolEdit] = useState(null);
    const [protocolDataEdit, setProtocolDataEdit] = useState(null);
    const [protocolIdSessions, setProtocolIdSessions] = useState(null);
    const [protocolInfo, setProtocolInfo] = useState(null);
    const [allProtocolTypes, setAllProtocolTypes] = useState(null);
    const [allMusicTypes, setAllMusicTypes] = useState(null);
    const [allTreatedSymptoms, setAllTreatedSymptoms] = useState(null);
    const [isTreatedSymptomsLoading, setIsTreatedSymptomsLoading] = useState(true);
    const [allAudioFrequencies, setAllAudioFrequencies] = useState(null);
    const [allPodLights, setAllPodLights] = useState(null);
    const [deletedRecord, setDeleteddRecord] = useState(null);
    const [editedRecord, setEditedRecord] = useState(null);
    const [isNewProtocol, setIsNewProtocol] = useState(false);
    const [modalDelete, setModalDelete] = useState(false);
    const [modalNotes, setModalNotes] = useState(false);
    const [modalEdit, setModalEdit] = useState(false);
    const [isReadOnlyModal, setIsReadOnlyModal] = useState(false);
    const [protocolModalReturnContext, setProtocolModalReturnContext] = useState(null);
    const [modalEditData, setModalEditData] = useState(false);
    const [isProtocolDataReadOnly, setIsProtocolDataReadOnly] = useState(false);
    const [isProtocolDataLoading, setIsProtocolDataLoading] = useState(false);
    const [modalFrequencySearch, setModalFrequencySearch] = useState(false);
    const [modalTreatedSymptoms, setModalTreatedSymptoms] = useState(false);
    const [modalSessions, setModalSessions] = useState(false);
    const [sessionCount, setSessionCount] = useState(0);
    const [records, setRecords] = useState([]);
    const [isTableLoading, setIsTableLoading] = useState(true);
    const [sort, setSort] = useState({ keyToSort: "name", direction: "asc"});
    const [showNotActive, setShowNotActive] = useState(false);
    const [searchText, setSearchText] = useState('');

    const normalizedSearchText = searchText.trim().toLowerCase();

    const matchesSearch = (record) => {
        if (!normalizedSearchText) {
            return true;
        }

        return [
            record.id,
            record.name,
            record.description,
            record.protocol_type_description,
            record.music_type,
            record.is_active,
            record.created_on,
            record.last_updated,
        ].some((value) => String(value ?? '').toLowerCase().includes(normalizedSearchText));
    };

    const sortedRecords = useMemo(() => {
        const recordsWithIndex = records.map((record, index) => ({ record, index }));

        const compareValues = (left, right) => {
            if (left === right) return 0;
            if (left === null || left === undefined) return -1;
            if (right === null || right === undefined) return 1;

            if (typeof left === 'boolean' || typeof right === 'boolean') {
                return Number(left) - Number(right);
            }

            if (typeof left === 'number' && typeof right === 'number') {
                return left - right;
            }

            const leftDate = Date.parse(left);
            const rightDate = Date.parse(right);
            if (!Number.isNaN(leftDate) && !Number.isNaN(rightDate)) {
                return leftDate - rightDate;
            }

            return String(left).localeCompare(String(right), undefined, { sensitivity: 'base' });
        };

        return recordsWithIndex.sort((a, b) => {
            const leftValue = a.record?.[sort.keyToSort];
            const rightValue = b.record?.[sort.keyToSort];
            const comparison = compareValues(leftValue, rightValue);

            return sort.direction === 'asc' ? comparison : -comparison;
        });
    }, [records, sort]);

    const visibleRecords = sortedRecords.filter(({ record }) => (showNotActive || record.is_active === true) && matchesSearch(record));

    const truncateDescription = (description) => {
        const text = String(description ?? '').replace(/\s+/g, ' ').trim();
        return text.length > 50 ? `${text.slice(0, 47)}...` : text;
    };


    const fetchAllProtocolData = useCallback(async () => {
        setIsTableLoading(true);
        try{
            const response = await fetch(fetchAllProtocolsUrl,
                {
                    method: 'GET',
                    headers: {
                        'machine':'2',
                        'vh-key':'7df7f81e-aaff-444c-a01c-8caeaeab3e61'
                    },
                });
            if (!response.ok) {
                throw new Error(`Fetch error - ${response.url} - Status: ${response.status}`);
            }
            const json = await response.json();
            setRecords(json);
        } catch (error) {
            console.error(error);
        } finally {
            setIsTableLoading(false);
        }
    }, [fetchAllProtocolsUrl])

    const fetchSingleProtocolData = useCallback(async (protocol_id, recordIndex) => {
        try{
            const response = await fetch(fetchSingleProtocolUrl.replace("*id*", protocol_id),
                {
                    method: 'GET',
                    headers: {
                        'machine':'2',
                        'vh-key':'7df7f81e-aaff-444c-a01c-8caeaeab3e61',
                    },
                });
            if (!response.ok) {
                throw new Error(`Fetch error - ${response.url} - Status: ${response.status}`);
            }
            const json = await response.json();
            setRecords(originalRecords => {
                const newRecords = [...originalRecords];
                newRecords[recordIndex] = json[0];
                return newRecords;
            });
        } catch (error) {
            console.error(error);
        }
    }, [fetchSingleProtocolUrl])

    const fetchAllProtocolTypes = useCallback(async () => {
        fetch(process.env.REACT_APP_API_URL_BASE + '/protocol_types/',
        {
            method: 'GET',
            headers: {
                'machine':'2',
                'vh-key':'7df7f81e-aaff-444c-a01c-8caeaeab3e61',
            },
        })
        .then(res => res.json())
        .then(data => {
            const protocolTypes = data.map(item => ({ description: item.description, id: item.protocol_type_id }));
            setAllProtocolTypes(protocolTypes)
        })
        .catch(error => console.error(error));
    }, [])

    const fetchAllMusicTypes = useCallback(async () => {
        fetch(process.env.REACT_APP_API_URL_BASE + '/music_types/',
        {
            method: 'GET',
            headers: {
                'machine':'2',
                'vh-key':'7df7f81e-aaff-444c-a01c-8caeaeab3e61',
            },
        })
        .then(res => res.json())
        .then(data => {
            const musicTypes = data.map(item => ({ description: item.description, id: item.music_type_id }));
            setAllMusicTypes(musicTypes)
        })
        .catch(error => console.error(error));
    }, [])

    const fetchAllTreatedSymptoms = useCallback(async () => {
        setIsTreatedSymptomsLoading(true);
        fetch(process.env.REACT_APP_API_URL_BASE + '/treated_symptoms/',
        {
            method: 'GET',
            headers: {
                'machine':'2',
                'vh-key':'7df7f81e-aaff-444c-a01c-8caeaeab3e61',
            },
        })
        .then(res => res.json())
        .then(data => {
            const treatedSymptoms = data.map(item => ({ symptom: item.symptom, id: item.treated_symptom_id }));
            setAllTreatedSymptoms(treatedSymptoms)
        })
        .catch(error => console.error(error))
        .finally(() => {
            setIsTreatedSymptomsLoading(false);
        });
    }, [])

    const fetchAllAudioFrequencies = useCallback(async () => {
        fetch(process.env.REACT_APP_API_URL_BASE + '/audio_frequencies/',
        {
            method: 'GET',
            headers: {
                'machine':'2',
                'vh-key':'7df7f81e-aaff-444c-a01c-8caeaeab3e61',
            },
        })
        .then(res => res.json())
        .then(data => {
            const audioFrequencies = data.map(item => ({ description: item.description, id: item.audio_frequency_id }));
            setAllAudioFrequencies(audioFrequencies)
        })
        .catch(error => console.error(error));
    }, [])

    async function fetchProtocolSessionCount(protocol_id) {
        try{
            const response = await fetch(process.env.REACT_APP_API_URL_BASE + '/sessions/protocol/' + protocol_id + '/count',
                {
                    method: 'GET',
                    headers: {
                        'machine':'2',
                        'vh-key':'7df7f81e-aaff-444c-a01c-8caeaeab3e61',
                    },
                });
            if (!response.ok) {
                throw new Error(`Fetch error - ${response.url} - Status: ${response.status}`);
            }
            const json = await response.json();
            setSessionCount(json.count);
            return json.count;
        } catch (error) {
            console.error(error);
            setSessionCount(0);
            return 0;
        }
    }

    async function fetchProtocolData(protocol_id) {
        try{
            const response = await fetch(process.env.REACT_APP_API_URL_BASE + '/protocols/protocol/' + protocol_id,
                {
                    method: 'GET',
                    headers: {
                        'machine':'2',
                        'vh-key':'7df7f81e-aaff-444c-a01c-8caeaeab3e61',
                    },
                });
            if (!response.ok) {
                throw new Error(`Fetch error - ${response.url} - Status: ${response.status}`);
            }
            const json = await response.json();
            return json[0]
        } catch (error) {
            console.error(error);
        }
    }

    async function fetchAllPodLights() {
        try{
            const response = await fetch(process.env.REACT_APP_API_URL_BASE + '/light_types/machine_type/2',
                {
                    method: 'GET',
                    headers: {
                        'machine':'2',
                        'vh-key':'7df7f81e-aaff-444c-a01c-8caeaeab3e61',
                    },
                });
            if (!response.ok) {
                throw new Error(`Fetch error - ${response.url} - Status: ${response.status}`);
            }
            const json = await response.json();
            return json
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        if (!window.sessionStorage.getItem("auth") || !hasReadPermission) {
            navigate('/unauthorized')
        }

        fetchAllProtocolData();
        fetchAllProtocolTypes();
        fetchAllMusicTypes();
        fetchAllTreatedSymptoms();
        fetchAllAudioFrequencies();
    }, [navigate, hasReadPermission, fetchAllAudioFrequencies, fetchAllMusicTypes, fetchAllProtocolData, fetchAllProtocolTypes, fetchAllTreatedSymptoms]);

    function handleHeaderClick(header) {
        if (!fieldsNoSort.includes(header.LABEL)){
            setSort((currentSort) => ({
                keyToSort: header.KEY,
                direction:
                    header.KEY === currentSort.keyToSort
                        ? (currentSort.direction === 'asc' ? 'desc' : 'asc')
                        : 'asc'
            }))
        }
    }

    const handleProtocolEdit = async (protocolInfo, recordIndex) => {
        // edit protocol info icon clicked
        // set the record in order to do a refresh on the edited protocol
        setEditedRecord(recordIndex)
        setProtocolEdit(protocolInfo)
        setIsNewProtocol(false);
        setIsReadOnlyModal(false);
                setProtocolModalReturnContext(null);
        setModalEdit(true);
      };

    const handleProtocolView = (protocolInfo, recordIndex, event) => {
        if (event.target.closest('.actions-cell') || event.target.closest('.info-cell')) {
            return;
        }

        setEditedRecord(recordIndex)
        setProtocolEdit(protocolInfo)
        setIsNewProtocol(false);
        setIsReadOnlyModal(true);
        setProtocolModalReturnContext(null);
        setModalEdit(true);
    };

    const restoreProtocolDetailsModalIfNeeded = () => {
        if (!protocolModalReturnContext) {
            return;
        }

        setProtocolEdit(protocolModalReturnContext.protocolInfo);
        setEditedRecord(protocolModalReturnContext.recordIndex);
        setIsReadOnlyModal(!!protocolModalReturnContext.isReadOnly);
        setIsNewProtocol(false);
        setModalEdit(true);
        setProtocolModalReturnContext(null);
    }

    const launchChildFromProtocolDetails = (protocolInfo, recordIndex, callback) => {
        setProtocolModalReturnContext({
            protocolInfo,
            recordIndex,
            isReadOnly: isReadOnlyModal,
        });
        setModalEdit(false);
        callback();
    }

    const handleProtocolDataEdit = async (protocolInfo, recordIndex, options = {}) => {
        const { isReadOnly = false } = options;
        // edit protocol info icon clicked
        // set the record in order to do a refresh on the edited protocol
        // console.log(protocolInfo.id)
        setEditedRecord(recordIndex)
        setProtocolEdit(protocolInfo)
        setIsNewProtocol(false);
        setIsProtocolDataReadOnly(!!isReadOnly);
        setModalEditData(true);

        setIsProtocolDataLoading(true);
        setProtocolDataEdit(null);
        setAllPodLights(null);

        try {
            const [protocolData, podLights] = await Promise.all([
                fetchProtocolData(protocolInfo.id),
                fetchAllPodLights(),
            ]);

            setProtocolDataEdit(protocolData || null);
            setAllPodLights(podLights || []);
        } finally {
            setIsProtocolDataLoading(false);
        }
    };

    const handleViewSessions = (protocolInfo) => {
        // View Sessions icon clicked
        setIsNewProtocol(false);
        setProtocolInfo(protocolInfo);
        setProtocolIdSessions(protocolInfo.id);
        setModalSessions(true);
    }

    const handleViewSessionsFromProtocolModal = (protocolInfo) => {
        launchChildFromProtocolDetails(protocolInfo, editedRecord, () => handleViewSessions(protocolInfo));
    }

    const handleViewNotes = (protocolInfo) => {
        // Notes icon clicked
        setIsNewProtocol(false);
        setProtocolInfo(protocolInfo);
        setModalNotes(true);
    }

    const handleViewNotesFromProtocolModal = (protocolInfo) => {
        launchChildFromProtocolDetails(protocolInfo, editedRecord, () => handleViewNotes(protocolInfo));
    }

    const handleViewProtocolDataFromProtocolModal = (protocolInfo) => {
        launchChildFromProtocolDetails(protocolInfo, editedRecord, () => {
            handleProtocolDataEdit(protocolInfo, editedRecord, { isReadOnly: isReadOnlyModal });
        });
    }

    const handleDeleteProtocol = async (protocolInfo, recordIndex) => {
        // Delete icon clicked
        if (userScopes.includes('delete:' + permissionScope)) {
            const count = await fetchProtocolSessionCount(protocolInfo.id);
            setSessionCount(count);
            setDeleteddRecord(recordIndex);
            setIsNewProtocol(false);
            setProtocolEdit(protocolInfo);
            setModalDelete(true);
        }
    }

    const handleNewProtocol = async () => {
        // new protocol button clicked - create a generic empty protocol object
        setProtocolEdit(null);
        setIsNewProtocol(true);
        setModalEdit(true);
      }

    const handleFrequencySearch = async () => {
        setModalFrequencySearch(true);
    }

    const handleTreatedSymptomsModal = () => {
        setModalTreatedSymptoms(true);
    }

    const handleEditSubmit = (newRow) => {
        if (isNewProtocol) {
            // pull all data - refresh page
            window.location.reload()
            setIsNewProtocol(false)
        }
        else {
            // edited existing protocol - update specific row
            if (editedRecord !== null && records[editedRecord]) {
                fetchSingleProtocolData(records[editedRecord].id, editedRecord)
            }
            setEditedRecord(null)
        }
      }

    const handleEditDataSubmit = (newRow) => {
        // edited existing protocol data
        setEditedRecord(null)
    }

    const handleNotesSubmit = () => {
        //  handle any necessary logic after a new has been added
    }

    const handleDeleteSubmit = (action) => {
        if (action === 'delete') {
            // remove the row from UI after permanent delete
            const newData = records.filter((_, i) => i !== deletedRecord);
            setRecords(newData);
        }
        else if (action === 'deactivate') {
            // refresh the updated protocol row after deactivation
            if (deletedRecord !== null && records[deletedRecord]) {
                fetchSingleProtocolData(records[deletedRecord].id, deletedRecord)
            }
        }
        setDeleteddRecord(null)
    }

    const showDelete = (record, recordIndex) => {
        // if the user has delete scope then show the delete icon
        if (canDeleteRecords) {
            return <BsFillTrashFill onClick={() => handleDeleteProtocol(record, recordIndex)} className='delete-btn' title='Delete or Deactivate this Protocol' aria-label='Delete or Deactivate this Protocol'/>
        }
    }

    const showEdit = (record, recordIndex) => {
        // if the user has edit scope then show the edit icon
        if (canEditRecords) {
            return <BsFillPencilFill onClick={() => handleProtocolEdit(record,recordIndex)} className='edit-btn' title='Edit Protocol' aria-label='Edit Protocol'/>
        }
    }

    const hasNotesPermission = userScopes.some((scope) =>
        scope.startsWith('create:protocolNotes') || scope.startsWith('update:protocolNotes')
    );

    const canDeleteRecords =
        userScopes.includes('delete:' + permissionScope) ||
        userScopes.some((scope) => scope.startsWith('create:' + permissionScope));

    const canEditRecords =
        userScopes.some((scope) => scope.startsWith('update:' + permissionScope)) ||
        userScopes.some((scope) => scope.startsWith('create:' + permissionScope));

    const canEditProtocolData = userScopes.includes('update:' + permissionScope);
    const canShowAnyActions = canDeleteRecords || canEditRecords || canEditProtocolData;
    const visibleHeaders = canShowAnyActions ? headers : headers.filter((header) => header.KEY !== 'actions');
    const canShowNotActiveToggle = userScopes.some((scope) =>
        scope.startsWith('create:protocolData') ||
        scope.startsWith('update:protocolData') ||
        scope.startsWith('delete:protocolData')
    );

    const showEditProtocolData = (record, recordIndex) => {
        // if the user has edit scope then show the edit icon
        if (canEditProtocolData) {
            return <BsLightbulbFill onClick={() => handleProtocolDataEdit(record,recordIndex)} className='sessions-btn' title='Edit Protocol Data' aria-label='Edit Protocol Data'/>
        }
    }

    const showCreateNew = () => {
        const canCreateProtocol = userScopes.some((scope) => scope.startsWith('create:' + permissionScope));

        if (canCreateProtocol || isCreatorUser) {
            return (
                <div className='protocols-action-buttons'>
                    {canCreateProtocol && <Link className='btn protocols-add-btn' onClick={() => handleNewProtocol()}>+ Add New Protocol</Link>}
                    {canCreateProtocol && <Link className='btn protocols-add-btn protocols-search-btn' onClick={() => handleFrequencySearch()}>Frequency Search</Link>}
                    {isCreatorUser && <Link className='btn protocols-add-btn protocols-treated-symptoms-btn' onClick={() => handleTreatedSymptomsModal()}>Treated Symptoms</Link>}
                </div>
            )
        }
    }

    function showDebug() {
        // var debugString = 'Sort Direction: ' + sort.direction + ' Sort Field: ' + sort.keyToSort;
        // // var debugString = sort.keyToSort === 'last_name' ? sort.direction : "asc"
        // return debugString
    }

    return (
        <div className='table-wrapper protocols-page'>
            {/*<h3 className='left'>&emsp;&ensp;Facilities{protocolInfo !== null ? ": " + protocolInfo.protocol_name : ""} ({records.length})</h3>*/}
            <h3 className='page-title'>
                Protocols <span className='page-count'>{visibleRecords.length}</span>
            </h3>
            <div>
                {showDebug()}
            </div>
            <div>
                {showCreateNew()}
            </div>
            <div className='facilities-filter'>
                <div className='table-search-input-wrap'>
                    <input
                        type='text'
                        className='facilities-search-input table-search-input'
                        placeholder='Search protocols...'
                        value={searchText}
                        onChange={(event) => setSearchText(event.target.value)}
                        aria-label='Search protocols'
                    />
                    <button
                        type='button'
                        className='table-search-clear-icon'
                        onClick={() => setSearchText('')}
                        disabled={!searchText}
                        aria-label='Clear protocol search'
                    >
                        x
                    </button>
                </div>

                {canShowNotActiveToggle && (
                    <label className='facilities-filter-label'>
                        <input
                            type='checkbox'
                            checked={showNotActive}
                            onChange={(event) => setShowNotActive(event.target.checked)}
                        />
                        Show Not Active
                    </label>
                )}
            </div>
            <font size="3">
            <table className='table'>
                <thead>
                    <tr>
                        {visibleHeaders.map((header, index) => (
                            <th key={index} className={header.CLASS} onClick={() => handleHeaderClick(header)}>
                                {header.LABEL}
                                {header.KEY === sort.keyToSort && (
                                <Caret direction={sort.keyToSort === header.KEY ? sort.direction : "asc"}/>)}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {
                        isTableLoading ? (
                            Array.from({ length: 6 }).map((_, rowIndex) => (
                                <tr key={`protocols-skeleton-${rowIndex}`} className='table-skeleton-row'>
                                    {visibleHeaders.map((header, cellIndex) => (
                                        <td key={`protocols-skeleton-${rowIndex}-${header.KEY}-${cellIndex}`}>
                                            <span className={`table-skeleton-line${header.KEY === 'info' || header.KEY === 'actions' ? ' short' : ''}`} />
                                        </td>
                                    ))}
                                </tr>
                            ))
                        ) : (
                            visibleRecords.map(({ record, index }) => {
                                return <tr key={record.id ?? index} onClick={(event) => handleProtocolView(record, index, event)}>
                                <td className='info-cell'>
                                    <span className='actions'>
                                        {hasNotesPermission && (
                                            <BsFileTextFill onClick={(event) => { event.stopPropagation(); handleViewNotes(record); }} className='sessions-btn' title='Protocol Notes' aria-label='Protocol Notes'/>
                                        )}
                                        <BsTable onClick={(event) => { event.stopPropagation(); handleViewSessions(record); }} className='sessions-btn' title='Show Session History' aria-label='Show Session History'/>
                                    </span>
                                </td>
                                <td className='left'>{record.id}</td>
                                <td className='left'>{record.name}</td>
                                <td className='left' title={record.description ?? ''}>{truncateDescription(record.description)}</td>
                                <td className='left'>{record.protocol_type_description}</td>
                                <td className='center'>{record.music_type}</td>
                                <td className='center'>{record.is_active ? "\u2714" : ""}</td>
                                <td className='center'>{format(new Date(record.created_on), 'MMM d, yyyy')}</td>
                                <td className='center'>{format(new Date(record.last_updated), 'MMM d, yyyy')}</td>
                                {canShowAnyActions && (
                                    <td className='actions-cell'>
                                        <span className='actions actions-three'>
                                            {showEdit(record,index)}
                                            {showEditProtocolData(record,index)}
                                            {showDelete(record,index)}
                                        </span>
                                    </td>
                                )}
                            </tr>
                            })
                        )}
                </tbody>
            </table>
            </font>
            {modalEdit && <ModalProtocolEdit closeModal={() => {
                setModalEdit(false)
                setIsReadOnlyModal(false)
                setProtocolModalReturnContext(null)
            }}
                onSubmit={handleEditSubmit}
                protocolEdit={protocolEdit}
                isNewProtocol={isNewProtocol}
                allProtocolTypes={allProtocolTypes}
                allMusicTypes={allMusicTypes}
                allTreatedSymptoms={allTreatedSymptoms}
                isTreatedSymptomsLoading={isTreatedSymptomsLoading}
                allProtocols={records}
                isReadOnly={isReadOnlyModal}
                onOpenSessionHistory={handleViewSessionsFromProtocolModal}
                onOpenProtocolLightData={handleViewProtocolDataFromProtocolModal}
                onOpenNotes={handleViewNotesFromProtocolModal}
            />}
            {modalEditData && <ModalProtocolEditData closeModal={() => {
                setModalEditData(false)
                setIsProtocolDataLoading(false)
                setIsProtocolDataReadOnly(false)
                restoreProtocolDetailsModalIfNeeded()
            }}
                onSubmit={handleEditDataSubmit}
                protocolEdit={protocolEdit}
                protocolDataEdit={protocolDataEdit}
                isNewProtocol={isNewProtocol}
                allPodLights={allPodLights}
                allSoundFrequencies={allAudioFrequencies}
                isLoading={isProtocolDataLoading}
                isReadOnly={isProtocolDataReadOnly}
            />}
            {modalSessions && <ModalProtocolSessions closeModal={() => {
                setModalSessions(false)
                restoreProtocolDetailsModalIfNeeded()
            }}
                protocolIdSessions={protocolIdSessions}
                protocolInfo={protocolInfo}
                sessionCount={sessionCount}
            />}
            {modalDelete && <ModalProtocolDelete closeModal={() => {
                setModalDelete(false);
                setSessionCount(0);
            }}
                onSubmit={handleDeleteSubmit}
                protocolEdit={protocolEdit}
                sessionCount={sessionCount}
            />}
            {modalNotes && <ModalProtocolNotes closeModal={() => {
                setModalNotes(false)
                restoreProtocolDetailsModalIfNeeded()
            }}
                onSubmit={handleNotesSubmit}
                protocolInfo={protocolInfo}
                isNewProtocol={isNewProtocol}
            />}
            {modalFrequencySearch && <ModalFrequencySearch closeModal={() => {
                setModalFrequencySearch(false)
            }}

            />}
            {modalTreatedSymptoms && <ModalTreatedSymptoms
                closeModal={() => {
                    setModalTreatedSymptoms(false)
                }}
                initialTreatedSymptoms={allTreatedSymptoms}
                isLoading={isTreatedSymptomsLoading}
                onRefreshTreatedSymptoms={fetchAllTreatedSymptoms}
            />}
        </div>
  )
}

export default Protocols



